import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tracker"];
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Header } from 'foundations-components/transitional/components/Header';
import { Link } from 'foundations-components/transitional/components/Link';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import useBackToCampaign from 'campaigns-lib/hooks/useBackToCampaign';
import { getContentPropertyValue, CONTENT_PLATFORM_PROPERTY_NAME, useAuthInfoProvider } from 'content-management-data-lib';
import ContentDetailActions from 'content-management-actions-lib/components/ContentDetailActions';
import useUsageTrackerProps from '../../hooks/useUsageTrackerProps';
import HeaderDetails from './HeaderDetails';
import { ContentStatusTags } from '../headerDetails/ContentStatusTag';
import EditableContentTitle from '../EditableContentTitle';
import HeaderDetailsPanel from './HeaderDetailsPanel';
import { useContentDetailsDataProvider } from '../../providers/ContentDetailsDataProvider';
import { DETAILS_INTERACTION } from '../../constants/trackerEvents';
import { CONTENT_ACTION_IDS } from 'content-management-actions-lib/constants/actionIds';
import { checkPermissions } from 'content-management-actions-lib/utils/permissions';
import { useDetailsRenderConfig } from '../../providers/DetailsRenderConfigProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentDetailsHeader = ({
  getBackBreadcrumbHref,
  onChangeLanguageVariation,
  PreviewImage,
  tabs,
  extraActionIdsToExclude,
  socialActionsConfig,
  actionsConfigOptions,
  additionalStatusTags
}) => {
  var _actionsConfigOptions;
  const {
    contentObject
  } = useContentDetailsDataProvider();
  const _useUsageTrackerProps = useUsageTrackerProps(),
    {
      tracker
    } = _useUsageTrackerProps,
    actionsTrackerProps = _objectWithoutPropertiesLoose(_useUsageTrackerProps, _excluded);
  const {
    userInfo
  } = useAuthInfoProvider();
  const {
    shouldDisplayBackToCampaign,
    BackToCampaignComponent
  } = useBackToCampaign();
  const {
    titleConfigOverride: {
      title: titleConfigOverride,
      canEdit: canEditConfigOverride
    }
  } = useDetailsRenderConfig();
  const [isDetailsPanelOpen, setIsDetailsPanelOpen] = useState(false);
  const contentId = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.ID);
  const contentTitle = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.NAME);
  const editActionConfig = (_actionsConfigOptions = actionsConfigOptions.actionsConfigOverrides) === null || _actionsConfigOptions === void 0 ? void 0 : _actionsConfigOptions.find(actionOverride => actionOverride.id === CONTENT_ACTION_IDS.EDIT);
  const title = titleConfigOverride !== undefined ? titleConfigOverride : contentTitle;
  const canEdit = canEditConfigOverride !== undefined ? canEditConfigOverride : checkPermissions({
    permissions: editActionConfig === null || editActionConfig === void 0 ? void 0 : editActionConfig.displayPermissions,
    scopes: userInfo.user.scopes,
    gates: userInfo.gates,
    isBulkAction: false,
    crmObjects: [contentObject],
    permissionsExtraData: {}
  });
  const BackMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "content-management-details-lib.header.backBreadcrumb"
  });
  const renderBreadcrumbs = () => /*#__PURE__*/_jsx(Breadcrumbs, {
    children: /*#__PURE__*/_jsx(Link, {
      href: getBackBreadcrumbHref(contentObject),
      onClick: () => {
        tracker.track(DETAILS_INTERACTION, {
          action: 'clicked-back-breadcrumb'
        });
      },
      children: BackMessage
    })
  });
  return /*#__PURE__*/_jsxs(Header, {
    breadcrumbs: shouldDisplayBackToCampaign ? /*#__PURE__*/_jsx(BackToCampaignComponent, {
      applicationId: "content-management-details-lib",
      label: BackMessage,
      renderFallbackComponent: renderBreadcrumbs,
      use: "breadcrumbsLink"
    }) : renderBreadcrumbs(),
    details: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ContentStatusTags, {
        contentObject: contentObject,
        additionalStatusTags: additionalStatusTags
      }), /*#__PURE__*/_jsx(HeaderDetails, {
        contentObject: contentObject,
        onChangeLanguageVariation: onChangeLanguageVariation,
        PreviewImage: PreviewImage,
        openDetailsPanel: () => {
          setIsDetailsPanelOpen(true);
          tracker.track(DETAILS_INTERACTION, {
            action: 'clicked-open-more-details-panel'
          });
        }
      })]
    }),
    tabs: tabs,
    title: canEdit ? /*#__PURE__*/_jsx(EditableContentTitle, {
      contentId: contentId,
      initialTitle: contentTitle
    }) : title,
    children: [/*#__PURE__*/_jsx(ContentDetailActions, {
      crmObject: contentObject,
      trackerProps: actionsTrackerProps,
      socialActionsConfig: socialActionsConfig,
      extraActionIdsToExclude: extraActionIdsToExclude,
      primaryActionId: actionsConfigOptions.primaryActionId,
      secondaryActionId: actionsConfigOptions.secondaryActionId
    }), isDetailsPanelOpen && /*#__PURE__*/_jsx(HeaderDetailsPanel, {
      contentObject: contentObject,
      closeDetailsPanel: () => setIsDetailsPanelOpen(false)
    })]
  });
};
export default ContentDetailsHeader;